import PropTypes from 'prop-types'
import { Table, Typography } from 'antd'
import { Link, generatePath } from 'react-router-dom'
import * as ROUTES from 'admin/routes'
import moment from 'moment'

export function NotificationList({ notifications, accountId, projectId }) {
  notifications.map(notification => (notification.accountId = accountId))
  notifications.map(notification => (notification.projectId = projectId))

  return (
    <Table
      columns={columns}
      dataSource={notifications}
      pagination={false}
      style={{ width: '100%', margin: '3rem 1rem' }}
    />
  )
}

const columns = [
  {
    title: 'Notification Name',
    dataIndex: 'displayName',
    sorter: (a, b) => a.displayName.localeCompare(b.displayName),
    width: '35%'
  },
  {
    title: 'ID',
    dataIndex: 'notificationDefinitionId',
    sorter: (a, b) =>
      a.notificationDefinitionId.localeCompare(b.notificationDefinitionId),
    width: '35%'
  },
  {
    title: 'Creation Date',
    dataIndex: 'createdAt',
    width: '10rem',
    render: createdAt => {
      return (
        <Typography.Text>
          {moment(createdAt).local().format('DD/MM/YYYY HH:mm')}
        </Typography.Text>
      )
    }
  },
  {
    title: 'Edit',
    key: 'edit',
    width: '5rem',
    render: notifications => {
      if (notifications.displayName == 'Record Alert Notification v1.0') {
        return (
          <Typography.Text key={notifications.notificationDefinitionId}>
            <Link
              to={generatePath(ROUTES.NOTIFICATIONS.EDIT, {
                accountId: notifications.accountId,
                projectId: notifications.projectId,
                notificationId: notifications.notificationDefinitionId
              })}
            >
              Edit
            </Link>
          </Typography.Text>
        )
      }
    }
  }
]

NotificationList.propTypes = {
  notifications: PropTypes.arrayOf(PropTypes.object),
  projectId: PropTypes.string.isRequired,
  accountId: PropTypes.string.isRequired
}
